// extracted by mini-css-extract-plugin
export default {"section":"RMSDualSplitBlock_section__5ZFiq","content":"RMSDualSplitBlock_content__HzepI"};